import React from 'react';
import type { FontSize, TextColor } from './Text';
import { getTextColor } from './textStyles';

const getFontSize = (size: FontSize): string => {
    switch (size) {
        case 'xsmall':
            return '12px';
        case 'small':
            return '14px';
        case 'medium':
            return '16px';
        case 'large':
            return '18px';
        case 'xlarge':
            return '20px';
        case 'xxlarge':
            return '24px';
        default:
            return '14px';
    }
};

export interface TerminalTextProps {
    bold?: boolean;
    size?: FontSize;
    children: React.ReactNode;
    color?: TextColor;
    className?: string;
    style?: React.CSSProperties;
}

const TerminalText: React.FC<TerminalTextProps> = ({
    bold = false,
    children,
    size = 'small',
    color = 'dimmed',
    className = '',
    style = {},
}) => {
    const terminalStyles: React.CSSProperties = {
        fontFamily: 'var(--malachite-font-mono, monospace)',
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: '4px',
        padding: '2px 4px',
        fontSize: getFontSize(size),
        fontWeight: bold ? 600 : 400,
        color: getTextColor(color),
        display: 'inline',
        ...style,
    };

    return (
        <code className={className} style={terminalStyles}>
            {children}
        </code>
    );
};

export default TerminalText;
